import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { UsuarioMultiselectComponent } from './usuario-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        UsuarioMultiselectComponent
    ],
    exports: [
        UsuarioMultiselectComponent
    ]
})
export class UsuarioMultiselectModule { }
